import { ICreateQuestion } from '@/contracts/modules/education/use-case/ICreateQuestion'
import { EnumWeight } from '@/contracts/modules/education/enum/EnumWeight'
import { CreateQuestionRoute } from '@/modules/education/v1/api/v1/questions/CreateQuestion/CreateQuestionRoute'
import { CreateQuestionParams } from '@/modules/education/v1/api/v1/questions/Dto/CreateQuestionParams'

export class CreateQuestion implements ICreateQuestion {
  async exec(node: string, weight: EnumWeight, key: string, data: string): Promise<string> {
    const response = await new CreateQuestionRoute().exec(new CreateQuestionParams({ node, weight, key, data }))
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData().uuid
  }
}
